import { render, staticRenderFns } from "./chats.vue?vue&type=template&id=31316fd5&scoped=true"
import script from "./chats.vue?vue&type=script&lang=js"
export * from "./chats.vue?vue&type=script&lang=js"
import style0 from "./chats.vue?vue&type=style&index=0&id=31316fd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31316fd5",
  null
  
)

export default component.exports